





































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { ExtendedBlob } from '@/shared/models/extended-blob'
import { EditableImageChangedEvent } from '@/shared/models/editable-image-changed-event'
import { dummyImage, imageUrl } from '@/shared/utils/images'
import { isNotBlank } from '@/shared/utils/is-blank'

@Component({
  data() {
    return {
      imageUrl: undefined,
    }
  },
})
export default class RespondecoImage extends Vue {
  @Prop({
    default: Number.NaN,
    type: Number,
  })
  public readonly aspectRatio!: number

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly editable!: boolean

  @Prop({
    type: Number,
  })
  public readonly height?: number

  @Prop({
    type: String,
  })
  public readonly image!: string

  @Prop({
    default: 'Bild hinzufügen',
    type: String,
  })
  public readonly placeholderText!: string

  @Prop({
    default: true,
    type: Boolean,
  })
  public readonly showPreviewImage!: boolean

  @Prop({
    default: 'jpeg',
    type: String,
  })
  public readonly type!: string

  @Prop({
    type: Number,
  })
  public readonly width!: number

  private imageUrl!: string

  public mounted() {
    this.onImageChanged(this.image)
  }

  @Watch('image')
  public onImageChanged(value: string) {
    if (isNotBlank(this.image)) {
      this.imageUrl = imageUrl(value, this.width, this.height)
    } else if (this.showPreviewImage) {
      const aspectRatio = isNaN(this.aspectRatio) ? 1 : this.aspectRatio
      const width = this.width || 300
      const height = Math.round(width / aspectRatio)

      this.imageUrl = dummyImage(width, height, this.placeholderText)
    }
  }

  public openFileChooser() {
    this.$modal.show('image-dialog', {
      aspectRatio: this.aspectRatio,
      fileType: 'image/' + this.type,
      onFileChanged: this.setNewImage,
    })
  }

  public setNewImage(blob: ExtendedBlob) {
    blob.name = 'image.' + this.type

    const fileReader = new FileReader()

    fileReader.onload = (event: any) => {
      if (event.target) {
        this.imageUrl = event.target.result

        this.$emit('imageChanged', new EditableImageChangedEvent(blob, event.target.result))
      }
    }

    fileReader.readAsDataURL(blob)
  }
}
